<template>
  <section class="lista">
    <!-- Busca -->
    <div class="busca">
      <div class="nome">
        <div class="icone">
          <Svgs nome="dinheiro" />
        </div>
        <p>{{ storeIntegracoes.integracoes?.length }} gateways</p>
      </div>
      <button class="adicionar hotmart" @click="integrar(hotmart)">
        <Svgs nome="logo-hotmart" />
      </button>
      <button class="adicionar kiwify" @click="integrar(kiwify)">
        <Svgs nome="logo-kiwify" />
      </button>
      <button class="adicionar ticto" @click="integrar(ticto)">
        <Svgs nome="logo-ticto" />
      </button>
    </div>
    <!-- Itens -->
    <div ref="listaRef" class="itens" :class="{ reordenando: state.reordenando }">
      <div class="balao" v-if="state.balao.visivel" :style="state.balao.posicao" ref="balao">
        <button @click="webhook(state.balao?.integracao)">
          <Svgs nome="integracao" />
          <p>Webhook</p>
        </button>
        <button @click="editar(state.balao?.integracao?._id)">
          <Svgs nome="editar" />
          <p>Editar</p>
        </button>
        <button class="excluir" @click="toggleExcluir(state.balao?.integracao?._id)">
          <Svgs nome="excluir" />
          <p>Excluir integracao</p>
        </button>
        <div class="exclusao" :class="{ mostrar: exclusaoAtivo === state.balao?.integracao?._id }">
          <p>Deseja excluir?</p>
          <div class="opcoes">
            <button class="confirmar" @click="confirmarExclusao(state.balao?.integracao?._id)" :disabled="state.excluindo">
              Sim
              <span></span>
            </button>
            <button class="cancelar" @click="toggleExcluir(state.balao?.integracao?._id)">Cancelar</button>
          </div>
        </div>
      </div>
      <div
        class="item"
        v-for="integracao in integracoesFiltradas"
        @contextmenu.prevent="abrirBalao($event, integracao)"
        :key="integracao._id"
        :class="{
          ativo: cursoAtivo === integracao._id || state.balao?.integracao?._id === integracao._id
        }">
        <div class="informacoes" @click="abrirModulos(integracao._id)">
          <div class="capa">
            <Svgs :class="integracao.gateway" :nome="`logo-${integracao.gateway}`" />
          </div>
          <div class="nome">
            <div class="titulo">
              <h3>{{ helperTexto.limitarCaracteres(integracao.nome, 55) }}</h3>
            </div>
          </div>
        </div>
        <div class="status">
          <Svgs nome="curso" />
          <h3>{{ integracao.idsCursos?.length }} cursos</h3>
        </div>
        <button class="abrir" @click="abrirBalaoClique(integracao)">
          <Svgs nome="bolinhas" />
        </button>
      </div>
    </div>
    <Teleport to="body">
      <CriarIntegracao />
      <EditarIntegracao />
      <EditarWebhook />
    </Teleport>
  </section>
</template>

<script setup>
import { computed, ref, watch, onUnmounted, reactive, inject, nextTick, onMounted } from 'vue'
import { useStoreAreas, useStoreIntegracoes, useStoreModulos, useStoreModal } from '@stores'
import { helperTexto } from '@helpers'
import CriarIntegracao from '@/components/editar/configuracoes/modals/CriarIntegracao.vue'
import EditarIntegracao from '@/components/editar/configuracoes/modals/EditarIntegracao.vue'
import EditarWebhook from '@/components/editar/configuracoes/modals/EditarWebhook.vue'
import Svgs from '@svgs'

const storeAreas = useStoreAreas()
const storeIntegracoes = useStoreIntegracoes()
const storeModulos = useStoreModulos()
const storeModal = useStoreModal()

const emitter = inject('emitter')
const searchQuery = ref('')
const selectedFilter = ref('todos')
const cursoAtivo = ref(null)
const exclusaoAtivo = ref(null)
const balao = ref(null)

const listaRef = ref(null)

const state = reactive({
  reordenando: false,
  posicaoAlterada: false,
  salvandoPosicoes: false,
  carregandoDuplicar: false,
  excluindo: false,
  balao: {
    visivel: false,
    posicao: { top: '0px', left: '0px' },
    integracao: null
  }
})

const abrirBalaoClique = (integracao) => {
  const listaRect = document.querySelector('.itens').getBoundingClientRect()

  const y = event.clientY - listaRect.top

  state.balao = {
    visivel: true,
    integracao,
    posicao: { top: `${y + 100}px`, right: '30px' }
  }

  nextTick(() => {
    document.addEventListener('click', cliqueForaBalao)
  })
}

const abrirBalao = (event, integracao) => {
  const listaRect = document.querySelector('.itens').getBoundingClientRect()

  const x = event.clientX - listaRect.left
  const y = event.clientY - listaRect.top

  state.balao = {
    visivel: true,
    integracao,
    posicao: { top: `${y + 100}px`, left: `${x}px` }
  }

  nextTick(() => {
    if (balao.value) {
      const balaoRect = balao.value.getBoundingClientRect()
      if (x + balaoRect.width > listaRect.width) state.balao.posicao.left = `${listaRect.width - balaoRect.width - 20}px`
      if (y + balaoRect.height > listaRect.height) state.balao.posicao.top = `${listaRect.height - balaoRect.height - 20}px`
      if (y < 0) state.balao.posicao.top = '20px'
    }

    document.addEventListener('click', cliqueForaBalao)
  })
}

const fecharBalao = () => {
  state.balao.visivel = false
  state.balao.integracao = null
  document.removeEventListener('click', cliqueForaBalao)
}

const cliqueForaBalao = (event) => {
  const isButtonClick = event.target.closest('.abrir')

  if (isButtonClick) {
    return
  }

  if (balao.value && !balao.value.contains(event.target)) {
    fecharBalao()
  }
}

function integrar(plataforma) {
  storeModal.abrirModalEdicao('criarIntegracao', 'dinheiro', 'Integrar Gateway', plataforma)
}

function webhook(integracao) {
  const idIntegracao = integracao._id
  const gateway = integracao.gateway
  storeModal.abrirModalEdicao('editarWebhook', 'integracao', `Webhook para ${gateway}`, idIntegracao)
}

const integracoesFiltradas = computed(() => {
  let integracoes = storeIntegracoes.integracoes || []

  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    integracoes = integracoes.filter((integracao) => {
      return integracao.nome?.toLowerCase().includes(query) || integracao.descricao?.toLowerCase().includes(query)
    })
  }

  switch (selectedFilter.value) {
    case 'alfabetica-asc':
      integracoes = integracoes.slice().sort((a, b) => a.nome.localeCompare(b.nome))
      break
    case 'alfabetica-desc':
      integracoes = integracoes.slice().sort((a, b) => b.nome.localeCompare(a.nome))
      break
    case 'mais-antigos':
      integracoes = integracoes.slice().sort((a, b) => new Date(a.dataRegistro) - new Date(b.dataRegistro))
      break
    case 'mais-novos':
      integracoes = integracoes.slice().sort((a, b) => new Date(b.dataRegistro) - new Date(a.dataRegistro))
      break
  }

  return integracoes
})

function toggleExcluir(id) {
  if (exclusaoAtivo.value === id) {
    exclusaoAtivo.value = null
    state.excluindo = false
  } else {
    exclusaoAtivo.value = id
  }
}

function novoCurso() {
  storeModal.abrirModal('criarCurso', 'integracao', 'Criar integracao')
}

async function abrirModulos(idCurso) {
  emitter.emit('iniciarCarregamento')
  const idArea = storeAreas.area._id

  await storeModulos.receberTodos(idArea, idCurso)
  await storeIntegracoes.receberPorId(idArea, idCurso)
  emitter.emit('pararCarregamento')
}

function editar(integracao) {
  storeModal.abrirModalEdicao('editarIntegracao', 'editar', 'Editar Integração', integracao)
}

async function confirmarExclusao(idCurso) {
  state.excluindo = true
  const idArea = storeAreas.area._id

  const delecaoOk = await storeIntegracoes.deletar(idArea, idCurso)
  if (delecaoOk !== true) return

  emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem: 'Integração excluída com sucesso' })
  emitter.emit('atualizarIntegracoes')
  state.excluindo = false
  fecharBalao()
}

async function receberIntegracoes() {
  const idArea = storeAreas.area?._id
  storeIntegracoes.receberTodos(idArea)
}

onUnmounted(() => {
  document.removeEventListener('click', cliqueForaBalao)
})

watch(
  () => storeAreas.area,
  (areaCarregada) => {
    if (areaCarregada) {
      receberIntegracoes()
    }
  },
  { immediate: true }
)

onMounted(() => {
  emitter.on('atualizarIntegracoes', receberIntegracoes)
})
</script>

<style scoped>
section.lista {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  position: relative;
}
.busca {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 0 20px 0;
}
.busca .nome {
  display: flex;
  align-items: center;
  margin-right: auto;
}
.busca .nome .icone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 10px;
  background-color: var(--cor-escuro-2);
}
.busca .nome .icone svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-branco);
}
.busca .nome p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  margin: 0 0 0 10px;
}
.busca button.adicionar.hotmart {
  background-color: #f04e23;
}
.busca button.adicionar.kiwify {
  background-color: #00ae6c;
}
.busca button.adicionar.ticto {
  background-color: #171717;
}
.busca button.adicionar {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-branco);
  padding: 12px 20px;
  background-color: var(--cor-marca);
  border-radius: 8px;
  margin: 0 0 0 10px;
  transition: all 0.3s;
}
.busca button.adicionar svg {
  width: 60px;
  max-height: 18px;
  fill: var(--cor-branco-fixo);
}
.busca button.adicionar:hover {
  opacity: 0.7;
}
.balao {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  width: 190px;
  min-width: 190px;
  background-color: var(--cor-escuro-2);
  border: 2px solid var(--cor-escuro-3);
  border-radius: 8px;
  padding: 10px 15px;
  z-index: 10;
  animation: fadeIn 0.3s linear;
}
.balao button {
  display: flex;
  align-items: center;
  padding: 7px 0;
  background-color: transparent;
}
.balao button svg {
  width: 12px;
  min-width: 12px;
  fill: var(--cor-escuro-6);
  margin: 0 10px 0 0;
  transition: all 0.3s;
}
.balao button p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  transition: all 0.3s;
}
.balao button:hover p {
  color: var(--cor-branco);
}
.balao button:hover svg {
  fill: var(--cor-branco);
}
.balao button.excluir svg {
  fill: var(--cor-vermelho);
}
.balao button.excluir p {
  color: var(--cor-vermelho);
}
.balao button.excluir:hover svg {
  fill: var(--cor-branco);
}
.balao button.excluir:hover p {
  color: var(--cor-branco);
}
.balao button:disabled svg {
  fill: transparent;
}
.balao button:disabled span {
  opacity: 1;
  visibility: visible;
}
.balao button span {
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2px solid var(--cor-branco);
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: girando 1s linear infinite;
  left: auto;
  opacity: 0;
  visibility: hidden;
}
.itens {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 8px;
  overflow-y: scroll;
  max-height: calc(100dvh - 200px);
  transition: all 0.3s;
  scrollbar-width: none;
}
.itens::-webkit-scrollbar {
  display: none;
}
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: var(--cor-escuro-2);
  border: 1px solid var(--cor-escuro-2);
  border-radius: 8px;
  margin: 0 0 20px 0;
  padding: 15px 0 15px 20px;
  position: relative;
  user-select: none;
  transition: all 0.3s;
}
.item.ativo {
  border: 1px solid var(--cor-escuro-4);
}
.item .informacoes {
  display: flex;
  align-items: center;
  margin-right: auto;
  cursor: pointer;
  transition: all 0.3s;
}
.item .informacoes:hover {
  transform: scale(1.05);
}
.item .capa {
  width: 80px;
  min-width: 80px;
  border-right: 1px solid var(--cor-escuro-4);
}
.item .capa svg {
  width: 60px;
  max-height: 20px;
  fill: var(--cor-branco);
}
.item .nome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 0 0 20px;
}
.item .nome .titulo {
  display: flex;
  align-items: center;
}
.item .nome h3 {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  line-height: 1.5;
}
.item .nome p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  line-height: 1.5;
  margin: 5px 0 0 0;
}
.item .status {
  display: flex;
  align-items: center;
  background-color: #0dc78f10;
  padding: 6px 10px;
  border-radius: 50px;
  margin: 0 20px 0 0;
}
.item .status svg {
  width: 10px;
  min-width: 10px;
  fill: var(--cor-verde);
  margin: 0 5px 0 0;
}
.item .status h3 {
  font-family: var(--bold);
  font-size: var(--f0);
  color: var(--cor-verde);
}
.item .duracao {
  display: flex;
  align-items: center;
  background-color: var(--cor-escuro-3);
  padding: 6px 10px;
  border-radius: 50px;
  margin: 0 20px 0 0;
}
.item .duracao svg {
  width: 10px;
  min-width: 10px;
  fill: var(--cor-escuro-6);
  margin: 0 5px 0 0;
}
.item .duracao p {
  font-family: var(--bold);
  font-size: var(--f0);
  color: var(--cor-escuro-6);
}
.itens .item.ativo button.abrir {
  background-color: var(--cor-escuro-4);
}
.item button.abrir {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background-color: var(--cor-escuro-3);
  margin: 0 20px 0 0;
  transition: all 0.3s;
}
.item button.abrir:hover {
  background-color: var(--cor-escuro-4);
}
.item button.abrir svg {
  width: 12px;
  min-width: 12px;
  fill: var(--cor-branco);
}
.exclusao {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background-color: var(--cor-escuro-2);
  border: 2px solid var(--cor-escuro-3);
  padding: 15px;
  z-index: 3;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s;
}
.exclusao.mostrar {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.exclusao p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-branco);
  line-height: 1.5;
  text-align: center;
  margin: 0 0 10px 0;
}
.exclusao .opcoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.exclusao .opcoes button {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--medium);
  font-size: var(--f1);
  text-align: center;
  width: calc(50% - 3px);
  padding: 10px;
  border-radius: 10px;
  position: relative;
  transition: all 0.3s;
}
.exclusao .opcoes button.confirmar:disabled {
  color: transparent;
}
.exclusao .opcoes button.confirmar:disabled span {
  opacity: 1;
  visibility: visible;
}
.exclusao .opcoes button.confirmar span {
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2px solid var(--cor-branco);
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: girando 1s linear infinite;
  left: auto;
  opacity: 0;
  visibility: hidden;
}
.exclusao .opcoes button.confirmar {
  background-color: var(--cor-vermelho);
  color: var(--cor-branco);
}
.exclusao .opcoes button.confirmar:hover {
  background-color: var(--cor-vermelho-escuro);
  opacity: 1;
}
.exclusao .opcoes button.cancelar {
  background-color: var(--cor-escuro-4);
  color: var(--cor-branco);
}
.exclusao .opcoes button.cancelar:hover {
  background-color: var(--cor-escuro-5);
  opacity: 1;
}
/* Responsivo */
@media screen and (max-width: 1024px) {
  section.lista {
    height: calc(100dvh - 130px);
  }
  .busca {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 0 20px 0;
  }
  .busca .input {
    width: calc(60% - 5px);
  }
  .busca .input input {
    padding: 12px 12px 12px 30px;
  }
  .busca .input svg {
    width: 12px;
    min-width: 12px;
    left: 12px;
  }
  .busca .select {
    width: calc(40% - 5px);
  }
  .busca .select select {
    padding: 12px 15px;
  }
  .busca .select svg {
    width: 12px;
    min-width: 12px;
    right: 12px;
  }
  .busca .reorganizar {
    display: none;
  }
  .item {
    flex-direction: column;
    align-items: flex-start;
    margin: 0 0 15px 0;
    padding: 15px;
    position: relative;
  }
  .item .informacoes {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .item .nome .titulo {
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
  }
  .item .nome .antigo {
    margin: 0 0 10px 0;
  }
  .item .capa {
    width: 100px;
    min-width: 100px;
  }
  .item .nome {
    padding: 15px 0 10px 0;
  }
  .item .nome:hover {
    opacity: 0.8;
  }
  .item .status {
    margin: 15px 0 0 0;
  }
  .item .links {
    margin: 0;
  }
  .item button.abrir {
    position: absolute;
    top: 10px;
    right: 10px;
    margin: 0;
  }
  .itens .item .botoes .lista {
    width: 180px;
    min-width: 180px;
  }
  .itens .item .botoes .lista button p {
    font-size: var(--f1);
  }
}
</style>
